import axios from 'src/adapters/axios';
import { uri } from 'src/config';
import { writable } from 'svelte/store';
const DEFAULT_FLOATING_WIDGET_SETTINGS = {
    loaded: false,
    metaData: {
        celebrity: false,
    },
    gates: null,
    periodicAutoShow: {
        active: false,
        showAfterMs: 3000,
        nextAfterMs: 5000,
        maxShowNum: 1,
    },
};
export const floatingWidgetSettingsStore = writable(Object.assign({}, DEFAULT_FLOATING_WIDGET_SETTINGS));
/**
 * Gets floating widget settings.
 */
export function getFloatingWidgetSettings(businessKey) {
    if (!businessKey) {
        console.error('Floating widget settings store: missing business key');
        return;
    }
    fetchFloatingWidgetSettings(businessKey);
}
let isFetching = false;
/**
 * Makes network call to fetch floating widget settings.
 */
function fetchFloatingWidgetSettings(businessKey) {
    if (isFetching)
        return;
    isFetching = true;
    axios
        .get(uri.floatingWidgetSettings, {
        params: {
            'business-key': businessKey,
        },
    })
        .then((res) => {
        floatingWidgetSettingsStore.update((data) => {
            return Object.assign(Object.assign({}, mergeSettingsWithDefault(data, res.data)), { loaded: true });
        });
    })
        .catch((e) => {
        console.log(e);
    })
        .finally(() => {
        isFetching = false;
    });
}
/**
 * Sets business key in settings.
 */
export function setBusinessKey(businessKey) {
    floatingWidgetSettingsStore.update((data) => {
        return Object.assign(Object.assign({}, data), { businessKey });
    });
}
/**
 * Merges fetched widget settings with current one.
 */
function mergeSettingsWithDefault(currentSettings, fetchedSettings) {
    // Filter out entries with undefined values
    const cleanedFetchedSettings = JSON.parse(JSON.stringify(fetchedSettings, (_key, value) => value !== null && value !== void 0 ? value : undefined));
    const mergedSettings = Object.assign(Object.assign({}, currentSettings), cleanedFetchedSettings);
    return mergedSettings;
}
